import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class SubMenu extends Component {
  render() {
    const { secondMenu, firstPath } = this.props;
    return (
      <Fragment>
        <ul className="sub-menu">
          {
            secondMenu.length > 0 && (
              secondMenu.map(item => {
                let path = item.path;
                if(!path){
                  path = firstPath + '/' + item.val;
                }
                return (
                  <li className="sub-menu__item" key={item.val} data-js-menu-item>
                  {
                    item.path ? (
                      <Link className="sub-menu__link" to={item.path}>{item.name}</Link>
                    ) : (
                      <Link className="sub-menu__link" to={{ pathname:path, query:{ name:item.name, val:item.val } }}>{item.name}</Link>
                    )
                  }
                </li>
                )
              })
            )
          }
        </ul>
      </Fragment>
    )
  }
}

export default connect(null, null)(SubMenu);
